exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__flipping-card-container___3-P9M{perspective:1000px;background-color:transparent;transition:.5s}.styles__flipping-card-container___3-P9M:hover .styles__flipping-card___3Epky{transform:rotateY(180deg)}.styles__flipping-card___3Epky{position:absolute;width:100%;height:100%;perspective:1000px;transition:.5s;transform-style:preserve-3d}", ""]);

// exports
exports.locals = {
	"flipping-card-container": "styles__flipping-card-container___3-P9M",
	"flipping-card": "styles__flipping-card___3Epky"
};